import Component from '../abstracts/Component';


export default class SizeGuideComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-size-guide',
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
  }


  bindEvents() {
    this.log('Size guide ready to be opened..');
  }

  render() {
    this.bindEvents();
  }
}
